interface IMobileContainer {
  children: React.ReactNode;
}
const MobileContainer = ({ children }: IMobileContainer) => {
  return <div className="mx-auto">{children}</div>;
};
export default MobileContainer;
